import React, { useEffect, useState } from 'react'
import classes from './signup.module.css'
import logo from '../../assets/images/new-logo.png'
import {
    LoginInput,
    ValidatedLoginInput,
} from '../../components/Form/Inputs/Inputs'
import { Button, ButtonIcon } from '../../components/Button/Button'
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg'
import loginImage from '../../assets/images/Login.jpg'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { getParentRoute } from '../../util/functions'
import { useDispatch, useSelector } from 'react-redux'
import { authSelectors } from '../../redux/authSlice'
import { Formik } from 'formik'
import { LoginSchema } from '../../util/formSchemas'
import { login } from '../../api/authApi'
import useAuthForm from '../../hooks/useAuthForm'
import { UserTypes } from '../../util/constants'
import { startWizard } from '../Wizard/wizardLogic'
import { userActions, userSelectors } from '../../redux/userSlice'

const BusinessLogin = ({ location, history }) => {
    const path = getParentRoute(location.pathname)

    const dispatch = useDispatch()

    const redirectUrl = useSelector(userSelectors.redirectUrl)

    useAuthForm(hasPlan => {
        if (hasPlan) {
            if (redirectUrl) {
                dispatch(userActions.resetRedirectUrl())
                history.push(redirectUrl)
            } else {
                history.push('/app/dashboard')
            }
        } else {
            history.push(startWizard())
        }
    }, true)

    const submitForm = values => {
        dispatch(login(values, true))
    }

    return (
        <div className={classes.container}>
            <Formik
                initialValues={{
                    email: '',
                    password: '',
                }}
                onSubmit={submitForm}
                validationSchema={LoginSchema}
            >
                {({ handleSubmit }) => (
                    <div className={classes.form}>
                        <img
                            src={logo}
                            alt="Logo"
                            className={classes.formLogo}
                            onClick={() => history.push('/')}
                        />
                        <h1 className={classes.formHeader}>
                            Sign up to start learning (Business User)
                        </h1>
                        <div className={classes.formInputs}>
                            <ValidatedLoginInput
                                placeholder={'Email Address'}
                                name={'email'}
                            />
                            <ValidatedLoginInput
                                placeholder={'Password'}
                                name={'password'}
                                type={'password'}
                            />
                        </div>
                        <Button
                            className={classes.formButton}
                            bold={false}
                            onClick={handleSubmit}
                        >
                            Log In
                            <ButtonIcon icon={<ArrowRight />} />
                        </Button>
                        <span className={classNames(classes.formSplitLine)} />
                        <p className={classes.formSignInText}>
                            Forgot Your Password?{' '}
                            <Link
                                to={`/app/auth/forgot-password`}
                                className={classes.formSignInTextOrange}
                            >
                                Reset it here
                            </Link>
                        </p>
                        <p className={classes.formSignInText}>
                            Don't have an account?{' '}
                            <Link
                                to={`${path}/sign-up`}
                                className={classes.formSignInTextOrange}
                            >
                                Sign Up
                            </Link>{' '}
                            as a business user
                        </p>
                        <p className={classes.formSignInText}>
                            Are you an individual user?{' '}
                            <Link
                                to={`/app/auth/sign-in`}
                                className={classes.formSignInTextOrange}
                            >
                                Sign In Here
                            </Link>
                        </p>
                    </div>
                )}
            </Formik>
            <img
                src={loginImage}
                alt="Login Page Background"
                className={classes.displayImage}
            />
        </div>
    )
}

export default BusinessLogin
